import SubmitExerciseAPI from '@/apis/business/teacher/submit-exercise-api.js'
import ExerciseCardAPI from '@/apis/business/teacher/exercise-card-api.js'
import Enumeration from '@/common/enumeration.js'
import { handleMappingAnswer } from '@/views/pages/teacher/storage/create/common/common.js'

export default {
  namespaced: true,
  state: {
    submitExercise: null,
    submitExercises: [],
    exerciseCard: null,
    teacherAssign: null
  },

  getters: {
    /**
     * @author PVThang
     * @description lấy submitExercise theo id
     */
    getSubmitExerciseById: (state) => (submitExerciseID) => {
      return state.submitExercises?.find(submitExercise => submitExercise.Id === submitExerciseID) || {}
    }
  },

  mutations: {
    setTeacherAssign (state, teacherId) {
      state.teacherAssign = teacherId
    },
    /**
     * @author PVThang
     * @description gán giá trị submitExercise
     * @param {*} state
     * @param {*} submitExercise
     */
    setSubmitExercise (state, submitExercise) {
      state.submitExercise = submitExercise
    },

    /**
     * @author PVThang
     * @description gán giá trị submitExercises
     * @param {*} state
     * @param {*} submitExercises
     */
    setSubmitExercises (state, submitExercises) {
      state.submitExercises = submitExercises
    },

    /**
     * @author PVThang
     * @description gán giá trị exerciseCard
     * @param {*} state
     * @param {*} exerciseCard
     */
    setExerciseCard (state, exerciseCard) {
      state.exerciseCard = exerciseCard
    },

    /**
     * @author PBac
     * @description Cập nhật lại giá trị status của Mark khi giáo viên chấm bài
     * @param {*} state
     * @param {*} status
     */
    setMarkStatus (state, params) {
      state.exerciseCard.Students.forEach((student, index) => {
        if (student.SubmitProgress.SubmitExerciseID === params.SubmitExerciseID) {
          if (!student.Mark?.MarkAttachment) {
            // Nếu chưa có thì bổ sung thêm trường Mark vào trong state
            student.Mark = params.Mark
          } else {
            // Nếu học sinh đã có Chữa nháp/Hoàn thành thì cập nhật Status
            student.Mark.Status = params.Mark?.Status || null
            student.Mark.Comment = params.Mark?.Comment || null
            if (params.Mark?.MarkAttachment) {
              student.Mark.MarkAttachment = params.Mark?.MarkAttachment
            }
          }
        }
      })
    },

    /**
     * Reset lại bài chữa khi nhấn xóa
     * @param {*} state
     * @param {*} SubmitExerciseID
     */
    resetExerciseMark (state, SubmitExerciseID) {
      state.exerciseCard.Students.forEach((student, index) => {
        if (student.SubmitProgress.SubmitExerciseID === SubmitExerciseID) {
          state.exerciseCard.Students[index].Mark = null
        }
      })
    },

    /**
     * Cập nhật nhận xét
     * @param {*} state
     * @param {*} params
     */
    updateExerciseComment (state, params) {
      state.exerciseCard.Students.forEach((student, index) => {
        if (student.SubmitProgress.SubmitExerciseID === params.id) {
          state.exerciseCard.Students[index].Mark.Comment = params.comment
        }
      })
    }
  },

  actions: {
    /**
     * @author PVThang
     * @description Lấy danh sách SubmitExercise theo ExerciseCard
     * @param {*} context
     * @param {*} exerciseCardID
     */
    async getByExerciseCard (context, exerciseCardID) {
      let res = {}

      if (!exerciseCardID) {
        res.Data = []
      } else {
        res = await SubmitExerciseAPI.getAsync(`exercise-card/${exerciseCardID}`)
      }
      context.commit('setSubmitExercises', res?.Data)
    },

    /**
     * @author PVThang
     * @description Lấy danh sách SubmitExercise theo ExerciseCard
     * @param {*} context
     * @param {*} exerciseCardID
     */
    async getSubmitExercise (context, submitExerciseID) {
      var res = {}

      if (!submitExerciseID) {
        res.Data = {}
      } else {
        res = await ExerciseCardAPI.getAsync(`grade-submit-exercise/${submitExerciseID}`)
        res.Data = handleMappingAnswer(res.Data, Enumeration.HandlePairingAnswerType.Revert)

        res?.Data && (res.Data.Id = submitExerciseID)
      }
      context.commit('setSubmitExercise', res?.Data)
      return res?.Data
    },

    /**
     * @author PVThang
     * @description Lấy ExerciseCard
     * @param {*} context
     * @param {*} exerciseCardID
     */
    async getExerciseCard (context, params) {
      let res = {}
      if (!params?.exerciseID) {
        res.Data = {}
      } else {
        res = await ExerciseCardAPI.getAsync(`exercise-card-detail/${params.exerciseID}?takeAll=${params?.takeAll}`)
        res.Data.ExerciseStore = handleMappingAnswer(res.Data.ExerciseStore, Enumeration.HandlePairingAnswerType.Revert)
      }

      context.commit('setExerciseCard', res?.Data)
    },

    async getTeacherAssignExercise (context, exerciseId) {
      const res = await ExerciseCardAPI.getAsync(`teacher-assign?id=${exerciseId}`)
      context.commit('setTeacherAssign', res?.Data)
    }
  }
}
